import { Injectable } from '@angular/core';
import { RoutePlannerOptionsData } from '../../models/route-model';
import { RoutePlannerService } from '../route-planner/route-planner.service';

@Injectable({
  providedIn: 'root'
})
export class RouteOptionsService {

  private routeOptionsData: RoutePlannerOptionsData;

  constructor(private routePlannerService: RoutePlannerService) {
    this.routeOptionsData = this.routePlannerService.routeDataModel.OptionsData;
  }

}
